
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/imageToBackground/components/imageToBackground.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_soo1m_7","backgroundIcon":"_backgroundIcon_soo1m_21"};